module.exports = __webpack_public_path__ + "static/mem-02-58b3e3f6e34bdb3fbd0b0e483ade10ab.jpg";